<template>
  <setting-item :title="title">
    <button class="button is-white" @click="expanded = !expanded">
      <b-icon :icon="expanded ? 'chevron-down' : 'chevron-right'"></b-icon>
    </button>

    <div v-if="expanded" slot="foot">
      <slot></slot>
    </div>
  </setting-item>
</template>

<script>
import SettingItem from "./SettingItem";

export default {
  props: ["title"],

  components: {
    SettingItem
  },

  data() {
    return {
      expanded: false
    };
  }
};
</script>
